var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MyADGVisitPopup.jinja');
require('./MyADGVisitPopup.less');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .MyADGVisitPopup-thanksClose': 'close', //function from BasePopup proto
        'click .MyADGVisitPopup-formSubmit': 'onSubmitClick',
        'input input': 'onInputChange',
        'input textarea': 'onInputChange'
    }, BasePopup.prototype.baseEvents),


    initialize: function (options) {
        this.options = options || {};

        this.inputValues = {};

        BasePopup.prototype.initialize.call(this, options);
    },


    onSubmitClick: function () {

        var data = this.getFormData();

        if (!data.valid) return;

        this.$('.MyADGVisitPopup-formSubmit').addClass('Button--loading');

        this._xhr = $.ajax({
            'url': Urls['member:api:request-visit']('json'),
            'data': JSON.stringify(data.data),
            'contentType': 'application/json; charset=utf-8',
            'dataType': 'json',
            'method': 'POST',
            'success': function (data) {
                this.$el.addClass('MyADGVisitPopup--submitted');
                if (app.settings.isPhone) {
                    $(window).scrollTop(0);
                }
                this.$('.MyADGVisitPopup-formSubmit').removeClass('Button--loading');
            }.bind(this),
            'error': function () {
                alert('Something went wrong, try again later.');
                this.$('.MyADGVisitPopup-formSubmit').removeClass('Button--loading');
            }.bind(this),
            'context': this
        });
    },


    onInputChange: function (e) {
        var data = this.getFormData();
        this.$('.MyADGVisitPopup-form').toggleClass('MyADGVisitPopup-form--filled', !!data.valid);
    },


    getFormData: function () {
        var productionName = this.$('input[name="production-name"]').val();
        var productionPhone = this.$('input[name="production-phone"]').val();
        var location = this.$('input[name="location"]').val();
        var typeOfProduction = this.$('input[name="type-of-production"]').val();
        var explanation = this.$('textarea[name="explanation"]').val();

        return {
            valid: productionName && productionPhone && location && typeOfProduction && explanation,
            data: {
                productionName: productionName,
                productionPhone: productionPhone,
                location: location,
                typeOfProduction: typeOfProduction,
                explanation: explanation
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGVisitPopup/MyADGVisitPopup.js
// module id = 291
// module chunks = 0